export var themeNamespace = '@atlaskit-shared-theme/button';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/modal-dialog/node_modules/@atlaskit/button/dist/esm/theme.js
// module id = 370
// module chunks = 0